import { Tray } from 'constants/interface';

export const buildTrayDisplay = (tray: Tray): string => {
  const display = `${tray.capacity}${tray.isHydroponic ? ' Hidro' : ''}`;
  return display;
};
